import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { UitpasClientCredentialsStatus } from '../UitpasClientCredentialsStatus.js';
export class UitpasSetClientCredentialsResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: new EnumDecoder(UitpasClientCredentialsStatus) })
], UitpasSetClientCredentialsResponse.prototype, "status", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], UitpasSetClientCredentialsResponse.prototype, "human", void 0);
export class UitpasGetClientIdResponse extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder })
], UitpasGetClientIdResponse.prototype, "clientId", void 0);
//# sourceMappingURL=UitpasSetClientCredentialsResponse.js.map